import { UiLinkModel } from "../../models";

export function mockUiLinkModel({
    id = "link-1234",
    type = "uiLink",
    locale = "en",
    content = mockUiLinkModelContent()
}: Partial<UiLinkModel> = {}): UiLinkModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiLinkModelContent = UiLinkModel["content"];

export function mockUiLinkModelContent({
    entryTitle = "Example Link",
    text = "Example link",
    url = "#link",
    ...optionals
}: Partial<UiLinkModelContent> = {}): UiLinkModelContent {
    return {
        entryTitle,
        text,
        url,
        ...optionals
    };
}
